module.exports = __webpack_public_path__ + "static/media/ZLA.cf064dd1.mp3";